export default "https://cdn-static.gokick.com/assets/545fd9dea55dc30417fabffa3a2a88024697daac/images/sleep-green-apple.f7a444510e3da94f2e4fec3a465032b1.png";